import { render, staticRenderFns } from "./AnchorTexts.vue?vue&type=template&id=74317ce7&"
import script from "./AnchorTexts.vue?vue&type=script&lang=js&"
export * from "./AnchorTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports